const saveData = (data) => {
    return fetch(
        "https://sistema.amdbrasil.com/Modulos/Seguro/Api/AmdApi.php",
        { method: "POST", body: JSON.stringify(data) }
        );
};

export default saveData;